<template>
  <b-row class="my-2">
    <b-col cols="md-3">
      <b-card header="Search Part" style="max-height:14.5rem;">
        <b-form class="my-2">
          <b-form-row class="my-2">
            <b-col>
              <b-form-input
                v-model="search.partNum"
                placeholder="Part Number"
                @keydown.enter.native="searchForItem"
                id="partNumField"
                class="mr-sm-2"
              />
            </b-col>
          </b-form-row>
          <b-form-row class='my-2'>
            <b-col>
              <b-form-input
                v-model="search.partDesc"
                placeholder="Description"
                @keydown.enter.native="searchForItem"
                id="partDescField"
                class="mr-sm-2"
              />
            </b-col>
          </b-form-row>
          <b-form-row class='my-2'>
            <b-col>
              <b-form-input
                v-model="search.productNum"
                placeholder="Product Number"
                @keydown.enter.native="searchForItem"
                id="partDescField"
                class="mr-sm-2"
              />
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col align-self="end">
              <b-button
                @click="searchForItem"
                @keydown.enter.native="searchForItem"
                variant="primary"
              >Search
              </b-button>
            </b-col>
          </b-form-row>
        </b-form>
      </b-card>
    </b-col>

    <b-col cols="md-9">
      <b-card header="Search Results">
        <b-row v-if="(rows > perPage) && !visibility.loading" align-h="between" class="my-2">
          <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            class="my-0">
          </b-pagination>
        </b-row>

        <b-table
          striped
          hover
          :busy="visibility.loading"
          class="search-table"
          :items="fishionInventoryCalcs"
          :currentPage="currentPage"
          :perPage="perPage"
          :fields="columns"
          style="table-layout:fixed;text-align: center;"
          ref='resultsTable'>

          <div slot="table-busy" class="text-center my-2">
            <strong>Loading results</strong>
            <center>
              <fingerprint-spinner :animation-duration="1500" :size="300" color="#293a93" class="my-3" />
            </center>
          </div>

          <template slot="available" slot-scope="row">
            <span v-if="row.item.item_type != 'Kit'">
              {{row.item.fb_available_for_sale}}  {{ row.item.uom }}
            </span>
            <span v-else>
              <i>n/a (Kit)</i>
            </span>
          </template>

          <template slot="canBuild" slot-scope="row">
            {{row.item.can_build_make}} {{ row.item.uom }}
          </template>

          <template slot="description" slot-scope="row">
            <span v-if="row.item.part_num != '0'" v-b-popover.hover.bottom="row.item.part_desc" class="desc">
              {{row.item.part_desc}}
            </span>
            <span v-else class="desc" v-b-popover.hover.bottom="row.item.product_desc">
              {{row.item.product_desc}}
            </span>
          </template>

          <template slot="num" slot-scope="row">
              <span v-if="row.item.part_num != '0'">{{row.item.part_num}}</span>
              <span v-else>{{row.item.product_num}}</span>
          </template>

          <template slot="addToOrder" slot-scope="row">
              <b-button
                v-if="canAdd(row.item)"
                :variant="buttonVariant(row.item)"
                v-b-popover.hover="buttonPopover(row.item)"
                size="sm"
                style="width: 30px;"
                @click="addToOrder(row.item)">
                  <i class="fas fa-plus"/>
              </b-button>
          </template>
        </b-table>
      </b-card>
    </b-col>

  </b-row>

</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
import { FingerprintSpinner } from 'epic-spinners';
const BASE_API = process.env.VUE_API_ROOT;

export default {
  name:'product-search',
  components: {
    FingerprintSpinner,
  },
  props: {
    parts: {
      type: Array,
    },
  },
  data() {
    return {
      search: {
        partNum:  this.$route.query.partNum,
        partDesc: this.$route.query.partDesc,
        productNum: this.$route.query.kitNum,
      },

      visibility: {
        loading: false,
        invalidPart: false,
      },

      allResults: false,
      currentPage: 1,
      perPage: 10,
      kit: {
        obj:     {},
        max:     1,
        qty:     1,
        visible: false,
      },
      columns: {
        num: {
          label: 'Number',
        },
        description: {
          label: 'Description',
          thStyle: {
            width: '35%',
          }
        },
        available: {
          label: 'Available for sale',
        },
        location: {
          label: 'Part Location',
        },
        canBuild: {
          label: 'Can Build/Make',
        },
        addToOrder: {
          label: 'Add to Order',
        },
      },
    }
  },
  computed: {
    ...mapGetters({
      fishionInventoryCalcs: 'fishionInventoryCalcs',
    }),
    rows() {
      return this.fishionInventoryCalcs.length;
    },
    btnVariant(item) {
      if (item.product_num == '0') {
        return 'danger';
      } else {
        return 'primary';
      }
    },

  },
  watch: {
    fishionInventoryCalcs() {
      this.fishionInventoryCalcs.forEach(item => {
        axios({
          method: 'POST',
          headers: { 'Content-Type': 'text/plain' },
          url: `${BASE_API}/fishbowl/parts/search-info`,
          data: { num: item.part_num },
        }).then(response => {
          item.location = response.data[0]['location'];
          this.$refs.resultsTable.refresh();
        }).catch(error => {
          console.error(`Something bad happened getting part location for ${item.part_num} => ${error}`);
        });
      });
      this.hideSpinner();
    }
  },
  methods: {
    ...mapActions({
      searchFishion: 'searchFishion',
      searchFishionForErrors: 'searchFishionForErrors',
    }),
    canAdd( part ) {
      let val = !this.isInOrder(part)
        && (part.fb_available_for_sale > 0 || part.can_build_make > 0)
        && (part.part_num.toUpperCase().indexOf('AUS')  == -1)
        && (part.part_num.toUpperCase().indexOf('FC')   == -1)
        && (part.part_num.toUpperCase().indexOf('PLTW') == -1);
        return val;
    },
    buttonVariant( part ) {
      if (part.item_type == 'Kit') {
        return 'warning';
      }
      else if (part.product_num != '0') {
        return 'primary';
      }
      else {
        return 'danger';
      }
    },
    buttonPopover( part ) {
      if (part.product_num == '0') {
        return 'This item has no product number and will be requested from ops separately'
      }
      else if (part.item_type == 'Kit') {
        return 'Add this and all kit subitems'
      }
    },
    addToOrder( part, quantity = 1 ) {
      this.kit.visible = false;
      this.$emit("add", part, quantity);
    },
    addItem( part ) {
      if (part.item_type == 'Kit') {
        this.kit.visible = true;
        this.kit.obj = part;
        this.kit.max = part.fb_available_for_sale + part.can_build_make;
        this.kit.qty = 1;
      }
      else {
        this.addToOrder(part);
      }
    },
    isInOrder( part ){
      for (let ix in this.parts) {
        if (this.parts[ix].level == 0 && this.parts[ix].num == (part.product_id == 0 ? part.part_num : part.product_num)) {
          return true;
        }
      }
      return false;
      // return this.parts.map(function(e) {return e.num;} ).indexOf((part.product_num == 0 ? part.part_num : part.product_num)) != -1;
    },
    searchForItem() {
      this.currentPage = 1;
      this.showSpinner();
      this.searchFishion(this.search);
      // this.$router.push({ path: 'house-order', query: this.search});
    },
    showSpinner() {
      this.visibility.loading = true;
    },
    hideSpinner() {
      this.visibility.loading = false;
    },
  },
  mounted() {
    if ( this.search.partNum
      || this.search.partDesc
      || this.search.kitNum) {
        this.searchForItem();
    }
  },
}

</script>

<style>
 .desc {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    padding-left: 10px;
    max-width: 100%;
  }

  div.search-table table tbody tr {
    height: 40px;
    vertical-align: middle;
  }

  table.search-table tbody tr td{
    padding: 5px 0;
    height: 42px;
  }

</style>



// WEBPACK FOOTER //
// src/components/sales-order/inventory-request/ProductSearch.vue